const data = [
  {
    title: "Search Autocomplete",
    shortDescription:
      "The 'Google-style' search bar. It predicts what you are looking for as you type, saving you keystrokes.",
    description:
      "This project teaches you how to filter data in real-time. Imagine you have a list of 1,000 users. You don't want to show them all at once. As the user types a letter (e.g., 'A'), your code listens to the input and runs the `.filter()` method. It checks every name in your list and asks: *'Does this name include the letter A?'* If yes, it shows it. If no, it hides it. It turns a static list into an interactive tool.",
  },
];

export default data;